module.exports = __webpack_public_path__ + "img/cyberclass-20.26b05a6a.svg";